import React, { useState } from "react";
import { get } from "../../../utility/fetch";
import "./labrequestTable.css";
import moment from "moment";
import LabReportTable from "./LabReports";

const TestStatusBadge = ({ isReportDone, awaitingReportApproval }) => {
  if (awaitingReportApproval) {
    return (
      <span className="lab-badge lab-badge--awaiting">Awaiting Approval</span>
    );
  }
  if (isReportDone) {
    return <span className="lab-badge lab-badge--done">Report Done</span>;
  }
  return <span className="lab-badge lab-badge--pending">Pending</span>;
};

const LabRequestTable = ({ data, isFamily, treatmentId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [patientsLabReport, setpatientsLabReport] = useState([]);
  const [opens2, setopens2] = useState(false);

  const fetchLabData = async (patientId, labRequestId) => {
    setIsLoading(true);
    try {
      const res = await get(
        `/lab/${patientId}/labrequest/${labRequestId}/internal_report`,
      );
      const report = res?.resultList ?? res?.data?.resultList ?? res?.data;
      setpatientsLabReport(report);
      setopens2(true);
    } catch (e) {
      console.error("Error fetching lab report:", e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="lab-request-wrapper">
      {isLoading && <p className="lab-loading-text">Loading report...</p>}

      <h2 className="lab-section-title">Lab Requests</h2>

      <div className="lab-table-container">
        <table className="lab-main-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Patient Name</th>
              <th>Diagnosis</th>
              <th>Note</th>
              <th>Tests</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((request) => (
              <tr key={request.id} className="lab-request-row">
                <td className="lab-date-cell">
                  <span className="lab-date">
                    {moment(request.createdAt).format("ll")}
                  </span>
                  <span className="lab-time">
                    {moment(request.createdAt).format("hh:mm A")}
                  </span>
                </td>
                <td className="lab-patient-cell">{request.patientFullName}</td>
                <td className="lab-diagnosis-cell">
                  {request.diagnosis || "—"}
                </td>
                <td className="lab-note-cell">
                  {request.additionalNote || "—"}
                </td>
                <td className="lab-tests-cell">
                  {request.testRequests?.length > 0 ? (
                    <table className="lab-sub-table">
                      <thead>
                        <tr>
                          <th>Lab Test</th>
                          <th>Lab Centre</th>
                          <th>Cost</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {request.testRequests.map((test) => (
                          <tr key={test.id}>
                            <td>
                              {test.internalLabService?.name ||
                                test.labTest?.name ||
                                "—"}
                            </td>
                            <td>{test.labCentre || "—"}</td>
                            <td>
                              ₦
                              {test.internalLabService?.cost?.toLocaleString() ??
                                "—"}
                            </td>
                            <td>
                              <TestStatusBadge
                                isReportDone={test.isReportDone}
                                awaitingReportApproval={
                                  test.awaitingReportApproval
                                }
                              />
                            </td>
                            <td>
                              {test.isReportDone && (
                                <button
                                  className="lab-btn-report"
                                  onClick={() =>
                                    fetchLabData(request.patientId, request.id)
                                  }
                                >
                                  View Report
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <span className="lab-no-tests">No tests recorded</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {opens2 && patientsLabReport && (
        <LabReportTable
          open={opens2}
          onClose={() => setopens2(false)}
          patientInfo={patientsLabReport}
          labreports={patientsLabReport}
        />
      )}
    </div>
  );
};

export default LabRequestTable;
